export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";